import React, { useState } from "react";
import styled from "styled-components";
import { NavLink, useLocation } from "react-router-dom";
import colors from "../utils/colors";
import logo from "../assets/logo.jpg";

const Head = styled.header`
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 0.55rem clamp(1rem, 4vw, 3rem);
    background-color: rgba(26, 35, 126, 0.96);
    backdrop-filter: blur(14px);
    box-shadow: 0 0.8rem 2rem rgba(26, 35, 126, 0.18);
    z-index: 999;

`;
const Logo = styled.div`
    margin: 0;
    padding: 0;

    img {
        width: 4rem;
        height: 4.1rem;
        border-radius: 0.45rem;
        object-fit: cover;
    }
`;
const Nav = styled.nav`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;

    @media screen and (max-width:770px) {
        position: fixed;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        top: 4.2rem;
        right: ${({ $active }) => ($active ? "1rem" : "-24rem")};
        background-color: ${colors.background};
        width: min(20rem, calc(100% - 2rem));
        padding: 1rem 1.25rem;
        height: auto;
        border-radius: 0.8rem;
        box-shadow: 0 1rem 2.5rem rgba(0, 0, 0, 0.28);
        transition: right 0.3s ease;
    }
`;

const Link = styled(NavLink)`
    font-weight: 600;
    font-size: 0.96rem;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 6.7rem;
    padding: 0.65rem 0.85rem;
    color: ${({ $active }) => $active ? colors.primaryColor : colors.textColor};
    position: relative;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
        color: ${colors.primaryColor};
    }

    &:hover::after {
        width: 65%;
    }

    &::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0.35rem;
        width: ${({ $active }) => ($active ? "48%" : 0)};
        height: 2px;
        border-radius: 999px;
        background-color: ${colors.primaryColor};
        transform: translateX(-50%);
        transition: width 0.3s ease;
    }

    @media screen and (max-width:770px) {
        justify-content: flex-start;
        width: 100%;
        padding: 0.85rem 0.2rem;
    }
`;

const Visible = styled.div`
    display: none;
    position: relative;
    right: 1rem;
    
    button {
        color: ${colors.primaryColor};
        cursor: pointer;
        font-size: 2rem;
        border: none;
        background: transparent;
        line-height: 1;
    }

    @media screen and (max-width:770px) {
        display: block;
        transition: 0.5s ease-in-out;
    }
`;

const Localization = styled.div`
    min-height: 3rem;
    font-size: 1rem;
    background-color: ${colors.lightBackground};
    padding: 1rem clamp(1rem, 4vw, 3rem);
    margin-top: 4rem;

    & + & {
        margin-top: 0;
        border-top: 1px solid rgba(69, 90, 100, 0.12);
    }
    
    span {
        color: ${colors.secondColor};
    }
    
    @media screen and (max-width:770px) {
        padding: 0.9rem 1rem;
        font-size: 0.78rem;
    }
`;

const Anchor = styled.a`
    text-decoration: none;
    cursor: pointer;
    color: ${colors.background}
`;

function Header() {
    const location = useLocation();
    const [active, setActive] = useState(false);

    const pathSegments = location.pathname.split("/").filter(Boolean);
    const decodedSegments = pathSegments.map(segment => decodeURIComponent(segment));
    const breadcrumbName = decodedSegments.join(" > ");


    const closeMenu = () => setActive(false);

    return (
        <>
            <Head>
                <Logo>
                    <NavLink to="/" onClick={closeMenu}>
                        <img
                            src={logo}
                            alt="LOGO-ROMS"
                        />
                    </NavLink>
                </Logo>

                <Nav $active={active}>
                    <Link to="/" $active={location.pathname === "/"} onClick={closeMenu}>Accueil</Link>
                    <Link to="/Apropos" $active={location.pathname === "/Apropos"} onClick={closeMenu}>A propos</Link>
                    <Link to="/Services" $active={location.pathname.startsWith("/Services")} onClick={closeMenu}>Services</Link>
                    <Link to="/Contacts" $active={location.pathname === "/Contacts"} onClick={closeMenu}>Contacts</Link>
                </Nav>
                <Visible>
                    <button aria-label={active ? "Fermer le menu" : "Ouvrir le menu"} onClick={() => setActive(prevActive => !prevActive)}>
                        <i className={active ? "bi bi-x" : "bi bi-list"}></i>
                    </button>
                </Visible>
            </Head>
            {location && location.pathname !== "/" && (
                <>
                    {/* <Localization>{breadcrumbName}</Localization> */}
                    <Localization>
                        <Anchor href="/">Accueil</Anchor>
                        <span> &gt; </span>
                        <Anchor href={location.pathname}>{breadcrumbName}</Anchor>
                    </Localization>
                </>
            )}
            <hr />
        </>
    );
}

export default Header;
